import { call, put, select, takeLatest } from "redux-saga/effects";
import { saveCatalogue as saveCatalogueApi } from "../../../services/coilConfiguratorApi";
import type { RootState } from "../../appState";
import { saveCatalogueSuccess, showToast } from "../actions";
import {
  SAVE_APPLICATION_STATE_SUCCESS,
  SAVE_CATALOGUE,
  SAVE_CATALOGUE_FAILURE,
} from "../types";

function* saveCatalogueSaga(): Generator {
  try {
    const catalogue = (yield select((state: RootState) => state.coilConfigurator.catalogue.active)) as RootState["coilConfigurator"]["catalogue"]["active"];
    yield call(saveCatalogueApi, catalogue);
    const updatedAt = new Date().toISOString();
    yield put(saveCatalogueSuccess(catalogue));
    yield put({ type: SAVE_APPLICATION_STATE_SUCCESS, updatedAt });
    yield put(showToast("Catalogue saved successfully."));
  } catch (error) {
    const message = error instanceof Error ? error.message : "Failed to save catalogue";
    yield put({ type: SAVE_CATALOGUE_FAILURE, error: message });
    yield put(showToast(message, "error"));
  }
}

function* catalogueWatcher(): Generator {
  yield takeLatest(SAVE_CATALOGUE, saveCatalogueSaga);
}

export default catalogueWatcher;
